export default "__VITE_ASSET__olcIILBo__"